import React from "react";
import ReactTable from "react-table";
import {
  currencyFormater,
  displayDateFormater,
} from "../../utils/lib";
import _ from "lodash-es";
import { Input } from "reactstrap";
import { BASE_URL, READY_FOR_EXPORT_STATUS_ID } from "../../constants";
import TooltipTitle from "../Common/TooltipTitle";

/**
 * @typedef Invoice
 * @property { number } id
 * @property { string } invoiceNumber
 * @property { string } invoiceDate
 * @property { string } clientName
 * @property { number } totalRebateAmount
 * @property { number } exportStatusId
 * @property { string } exportStatusName
 *
 * @typedef MYOBListProps
 * @property { Invoice[] } invoiceList
 * @property { (checked: boolean) => void } handleAllSelected
 * @property { boolean } allSelected
 * @property { number[] } selectedRows
 * @property { (item: Invoice) => void } handleCheckboxSelection
 * @property { any[] } exportInvoiceList
 * @property { (item: Invoice) => void } handleView
 * @property { boolean } searching
 */

/**
 * @param { MYOBListProps } Props
 */
const MYOBList = ({
  handleAllSelected,
  handleCheckboxSelection,
  allSelected = false,
  handleExport,
  handleView,
  exportInvoiceList = [],
  selectedRows = [],
  invoiceList = [],
  searching
}) => {
  /**
   * @type {import("react-table").Column<Invoice>}
   */
  const getListColumns = [
    {
      id: "selected",
      accessor: (x) => x.selected,
      Header: (
        <div className="flex justify-content-center pl-1 selectableRowCheckbox">
          <Input
            type="checkbox"
            onChange={(e) => handleAllSelected(e.target.checked)}
            checked={allSelected}
            disabled={_.isEmpty(invoiceList)}
          />
        </div>
      ),
      maxWidth: 60,
      sortable: false,
      Cell: (row) => (
        <div className="flex justify-content-center pl-1 selectableRowCheckbox">
          <Input
            type="checkbox"
            onChange={() => handleCheckboxSelection(row.original)}
            checked={
              selectedRows.includes(row.original.id) &&
              row.original.canExport
            }
            disabled={
              !row.original.canExport
            }
          />
        </div>
      ),
    },
    {
      id: "id",
      Header: "Invoice No.",
      accessor: (x) => x.id,
      maxWidth: 100,
      Cell: (row) => (
        <div
          className="text-primary hand"
          onClick={(e) => handleView(row.original)}
        >
          {row.original.invoiceNumber}
        </div>
      ),
    },
    {
      id: "invoiceDate",
      Header: "Date",
      accessor: (x) => x.invoiceDate,
      maxWidth: 130,
      Cell: (row) => (
        <div>{displayDateFormater({ value: row && row.value })}</div>
      ),
    },
    {
      id: "clientName",
      Header: "Client Name",
      accessor: (x) => x.clientName,
      maxWidth: 250,
    },
    {
      id: "totalRebateAmount",
      Header: "Total",
      accessor: (x) => x.total,
      Cell: (row) => (
        <div className="text-right pr-q">
          {currencyFormater(row && row.value)}
        </div>
      ),
    },
    {
      id: "exportStatus",
      Header: "Export Status",
      accessor: (x) => x.exportStatusName,
      Cell: (row) => (
        <div className="pl-h">
          {(row && row.value) === "Export Error" ? (
            <TooltipTitle
              text={row.value}
              tooltipTitle={row.original && row.original.exportDiagnostics}
              id={row.original && row.original.id}
              titleClassName="hand"
            />
          ) : (
            row && row.value
          )}
        </div>
      ),
    },
    {
      id: "actions",
      Header: "",
      sortable: false,
      Cell: (row) =>
        row.original.canExport ? (
          <div className="text-center">
            <button
              className={`btn btn-success btn-sm bold ${
                exportInvoiceList.includes(
                  row.original && row.original.id
                )
                  ? "no-pointer-events"
                  : ""
              }`}
              onClick={() => handleExport({ data: row.original })}
            >
              <i className={"fa fa-arrow-up"} /> &nbsp;
              {exportInvoiceList.includes(
                row.original && row.original.id
              )
                ? "Exporting"
                : "Export"}
            </button>
          </div>
        ) : (
          <React.Fragment />
        ),
      maxWidth: 110,
    },
  ];

  return (
    <ReactTable
      sortable
      filterable={false}
      showPagination={true}
      data={invoiceList}
      defaultPageSize={20}
      loading={searching}
      columns={getListColumns}
      minRows={
        invoiceList.length === 0
          ? 5
          : invoiceList.length > 20
          ? 20
          : invoiceList.length
      }
      className="selectableRowTable"
      defaultSorted={[
        {
          id: "invoiceDate",
          desc: true,
        },
      ]}
    />
  );
};
export default MYOBList;
